export default function ({ store, redirect }) {
  // if (!store.getters[`members/isAuthenticated`]) {
  //   if (store.state.members.hasTokenExpired) {
  //     redirect(`/login?signed_out=true`);
  //   } else {
  //     redirect(`/login`);
  //   }
  // }
}
